
import Footer from '../../components/common/Footer'
import OrganizationMain from '../../components/organization/OrganizationMain'
// import RegisterMoreDetails from '../../components/registration/RegisterMoreDetails'
import RegisterNavbar from '../../components/registration/RegisterNavbar'

export default function RegisterMoreDetailsPage() {
    return (
        <>
            <RegisterNavbar />
            <OrganizationMain starting={true}/>
            <Footer/>
            {/* <RegisterMoreDetails /> */}
        </>
    )
}
